import { render, staticRenderFns } from "./ViewOffice.vue?vue&type=template&id=f94783e6&scoped=true"
import script from "./ViewOffice.vue?vue&type=script&lang=js"
export * from "./ViewOffice.vue?vue&type=script&lang=js"
import style0 from "./ViewOffice.vue?vue&type=style&index=0&id=f94783e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94783e6",
  null
  
)

export default component.exports